import React from 'react'
import { PriceInput } from './PriceInput'
import { TakePriceModifier, TAKE_PRICE_MODIFIERS } from '../../types/database'
import { formatModifier } from '../../utils/formatters'

interface PriceInputWithModifierProps {
  value: number | null | undefined
  modifier: TakePriceModifier | null | undefined
  onValueChange: (value: number | null) => void
  onModifierChange: (modifier: TakePriceModifier | null) => void
  placeholder?: string
  disabled?: boolean
  label?: React.ReactNode
}

/**
 * A combined price input with a modifier dropdown.
 * The modifier options are: +, -, +-, Motivated, Firm, Some Room
 * These are appended to the price display with a space.
 */
export const PriceInputWithModifier: React.FC<PriceInputWithModifierProps> = ({
  value,
  modifier,
  onValueChange,
  onModifierChange,
  placeholder = 'Enter price in millions (e.g., 1.234)',
  disabled = false,
  label
}) => {
  return (
    <div>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <div className="flex gap-2">
        <div className="flex-1">
          <PriceInput
            value={value}
            onChange={onValueChange}
            placeholder={placeholder}
            disabled={disabled}
            flexibleDecimals={true}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent"
          />
        </div>
        <div className="w-28 flex-shrink-0">
          <select
            value={modifier || ''}
            onChange={(e) => onModifierChange(e.target.value as TakePriceModifier || null)}
            disabled={disabled}
            className="w-full h-full px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent text-sm bg-white"
          >
            <option value="">None</option>
            {TAKE_PRICE_MODIFIERS.map((mod) => (
              <option key={mod} value={mod}>
                {formatModifier(mod) || mod}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}

export default PriceInputWithModifier

